import { createPlugin } from './pm-plugins/main';
export var submitEditorPlugin = function submitEditorPlugin(_ref) {
  var onSave = _ref.config,
    api = _ref.api;
  return {
    name: 'submitEditor',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'submitEditor',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch;
          return createPlugin(dispatch, api, onSave);
        }
      }];
    }
  };
};